import {
  createRouteRef,
  createSubRouteRef,
} from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();

export const rolesRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/roles',
});

export const roleEditRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/roles/:id/edit',
});

export const roleDetailRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/roles/:id',
});

export const bindingsRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/bindings',
});

export const bindingEditRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/bindings/:id/edit',
});

export const bindingDetailRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/bindings/:id',
});

export const reconcilerRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/reconciler',
});

export const auditLogRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/audit-log',
});
